import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import ContextProviders from 'contexts/ContextProviders';
import { ToastProvider } from 'contexts/ToastContext';
import { NotificationProvider } from 'contexts/NotificationContext';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';


const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
    <React.StrictMode>
        <I18nextProvider i18n={i18n}>
            <ContextProviders>
                <NotificationProvider>
                    <ToastProvider>
                        <BrowserRouter>
                            <App />
                        </BrowserRouter>
                    </ToastProvider>
                </NotificationProvider>
            </ContextProviders>
        </I18nextProvider>
    </React.StrictMode>
);

reportWebVitals();

